import { Root } from '@/App';
import { Layout } from '@/components/Layout';
import ModuleAtualizacao from '@/modules/Atualizacoes';
import AuditoriaModule from '@/modules/Auditoria';
import ModuleCadastro from '@/modules/Cadastro';
import ConfiguracaoModule from '@/modules/Configuracao';
import EntradasModule from '@/modules/Entradas';
import ExpedicoesModule from '@/modules/Expedicoes';
import { ModuleFakeErp } from '@/modules/FakeRp';
import LogoutModule from '@/modules/Logout';
import MovimentacoesModule from '@/modules/Movimentacoes';
import ModulePainel from '@/modules/Paineis';
import ModulePermissoes from '@/modules/Permissoes';
import ModuleRelatorio from '@/modules/Relatorio';
import { SignIn } from '@/modules/SignIn';
import { createBrowserRouter } from 'react-router-dom';
import { Error } from './Error';
import { Page404 } from './Error/404';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';

// import ModulePortaria from '@/modules/Portaria';
// import ModuleAcompanhamentoPortaria from '@/modules/AcompanhamentoPortaria';

export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <Error />,
    element: <Root />,
    children: [
      {
        path: '',
        element: (
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        ),
        children: [
          ...ModuleCadastro.routes,
          ...ModuleRelatorio.routes,
          ...EntradasModule.routes,
          ...MovimentacoesModule.routes,
          ...ExpedicoesModule.routes,
          ...AuditoriaModule.routes,
          ...ModuleFakeErp.routes,
          ...ModulePainel.routes,
          ...ModulePermissoes.routes,
          ...ModuleAtualizacao.routes,
          ...LogoutModule.routes,
          ...ConfiguracaoModule.routes,

          // ...ModulePortaria.routes,
          // ...ModuleAcompanhamentoPortaria.routes,

        ],
      },
      {
        path: "signin",
        element: (
          <PublicRoute>
            <SignIn />,
          </PublicRoute>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Page404 />
  }
]);
